import { useAtomValue } from "jotai";
import { useRouter } from "next/router";
import qs from "qs";
import { useEffect } from "react";
import { BookmarkAction } from "scmp-sdk";

import { accountAtom } from "shared/lib/account";
import { useRouterReplaceWithSanitizedKeys } from "shared/lib/router";

import type { BookmarkQueryStringPayload } from "scmp-app/components/content/content-bookmark/types";
import { useLoginDialogStateHelper } from "scmp-app/components/login-dialog/hooks";
import { useUserService } from "scmp-app/lib/user-service/hooks";

import { SanitizedUrlKeys } from "./consts";

export const useContentBookmarkActionRedirect = () => {
  const { bookmarkAction } = useUserService();
  const { asPath, pathname, query } = useRouter();
  const replace = useRouterReplaceWithSanitizedKeys();

  const { user } = useAtomValue(accountAtom);

  const { openLoginDialog } = useLoginDialogStateHelper();

  // NOTE: Need to check isDataReady because this component occurs before the component
  //       containing SWR to fetch the data, reason for this component occurring before SWR is
  //       because we do not want to declare this component on a per page basis
  useEffect(() => {
    const parsedQueryString = qs.parse(window.location.search, {
      ignoreQueryPrefix: true,
    }) as unknown as BookmarkQueryStringPayload;

    if (!parsedQueryString.action?.bookmark) {
      return;
    } else if (parsedQueryString.action?.bookmark && !user?.uuid) {
      openLoginDialog({
        destination: window.location.href,
        ga4CustomParameter: {
          trigger_point: "bookmark",
        },
      });
    } else if (parsedQueryString.action?.bookmark) {
      void bookmarkAction(BookmarkAction.Bookmark, parsedQueryString.action.bookmark, {}, () => {
        void replace(
          SanitizedUrlKeys,
          { pathname, query },
          {
            shallow: true,
          },
        );
      });
    }
  }, [asPath, pathname, query, replace, openLoginDialog, user?.uuid, bookmarkAction]);

  return null;
};
